import React from "react";
import SignupForm from "../components/signupForm";
import Navbar from "../components/navbar";
import Footer from "../components/footer";

function SignupPage() {
  return (
    <>
      <Navbar />
      <SignupForm />
      <Footer />
    </>
  );
}

export default SignupPage;
